import React, { useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import { getEndpoint, getUrl, processArticleBody_New, setCmsSeoData } from './../../common/utils';
import './StaticComponent.css';
import bcrypt from 'bcryptjs-react';

StaticPage.version = 1000;

StaticPage.lang = 'en';
StaticPage.langs = [
    'en'
];
StaticPage.setLang = (lang: any) => {
    StaticPage.lang = lang;
}

Object.defineProperty(StaticPage, 'name', {
    writable: true,
    value: 'StaticPage'
});

export function StaticPage(props: any) {
    const [showData, setData] = useState<any>([]);
    let [completeBody, setCompleteBody] = useState<any>('');
    let [embeds, setEmbeds] = useState<any>([]);
    let [cmsembeds, setCmsembeds] = useState<any>([]);
    
    const { showTitle } = props;

    const endpoint = getEndpoint(props, "MAIN");
    useEffect(() => {
        if (!endpoint.isSSR || !endpoint.SSRDataObj) {
            fetchComponentData();
        }
    }, []);

    const fetchComponentData = () => {
        getData(getUrl(props, 1, false, 'MAIN', true));
    }

    const setResponseOfAPI = (response: any) => {
        setData(response.it);
        const bodySnippet: String = '';
        // const adSize: any = 1;

        let articleData = {
            title: response?.it?.hl,
            permaLink: response?.it?.wu,
            summary: response?.it?.syn,
            tags: response?.it?.metaKws,
            body: response?.it?.processStory,
            publishedDate: response?.it?.published,
            updatedDate: response?.it?.updated,
            baseDomain: response?.it?.pubInfo?.baseDomain,
            authors: response?.it?.authors
        };

        setEmbeds(response?.it?.embeds);
        setCmsembeds(response?.it?.cmsembed);

        setCompleteBody({ articleBody: articleData.body, embeds, cmsembeds, baseDomain: articleData.baseDomain, CONSTANTS: props.CONSTANTS, bodySnippet, adSize: props.adSize });
    }

    if (endpoint.isSSR && endpoint.SSRDataObj && showData && Object.keys(showData).length === 0) {
        setResponseOfAPI(endpoint.SSRDataObj);
        setCmsSeoData(props, endpoint.SSRDataObj, "StaticPage");
    }

    const getData = (url: any) => {

        let headerString = '?' + url.split("?")[1];
        headerString = bcrypt.hashSync(headerString, 6);
        const headers = {'p-nonce': headerString};
        
        fetch(url, { headers: headers })
            .then((response) => response.json())
            .then(response => {
                setResponseOfAPI(response);
                setCmsSeoData(props, response, "StaticPage");
            })
            .catch(err => {
                //console.log(err);
            });
    }

    return (
        <React.Fragment>
            <div className="static-headingRow">
                <Typography className='title' variant='h3'>
                    {showTitle && showData && showData.hl}
                </Typography>
            </div>
            <div className="page-content">
                {completeBody &&
                    <Typography component="div">
                        {processArticleBody_New(completeBody?.articleBody , completeBody?.embeds, completeBody?.cmsembeds, completeBody?.baseDomain, completeBody?.CONSTANTS, undefined, completeBody?.adSize, props.clientHostId)}
                    </Typography>
                }
            </div>
        </React.Fragment>
    );
}
